import {useDispatch} from "react-redux";
import React, {useContext} from "react";
import {GeoJSONLayer, MapContext} from "react-mapbox-gl";
import {changes as Rchanges} from "../redux/changesDuck";

export function ChangesLayer(props) {
    const dispatch = useDispatch();
    const map = useContext(MapContext)

    const {changes, dataUrl} = props
    if (!changes.features) {
        return null
    }
    const setFocusOnClick = (e) => {

        const clicked = map.queryRenderedFeatures(e.point)

        const active = clicked.filter((f) => f.layer.id == 'geojson_changes-fill')[0]
        dispatch(Rchanges.actions.setFocus([active.properties.event_id]))
    }
    return (<GeoJSONLayer id='geojson_changes' fillOnClick={setFocusOnClick}
                          data={
                              changes}
                          fillPaint={{
                              'fill-outline-color': [
                                  "case", ['==', ["get", "event_id"], props.selectedValue],
                                  "#EE0000",
                                  "#eee695"
                              ], 'fill-color': 'rgba(0,0,0,0)'
                          }}

        />
    )

}



// WEBPACK FOOTER //
// ./src/components/ChangesLayer.js